import { CloseCircleFilled, SearchOutlined, SwapRightOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row } from 'antd';
import React, { ReactElement, useRef, useState } from 'react';
import { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import { replaceRsAndComma } from '../../../utils/utility';
import { GUTTOR_SPACE_SMALL } from '../../constants/commonConstants';

interface IAmountRangeSelector {
  value: string[];
  onChange: any;
  isSearchButtonRequired?: boolean;
  onSearch?: any;
  ref?: any;
  className?: any;
}
const AmountRangeSelector = ({
  value = ['', ''],
  onChange = (): any => { },
  isSearchButtonRequired = true,
  onSearch = (): any => { } }: IAmountRangeSelector): ReactElement => {

  const [err, setErr] = useState('');
  const [clicked, setClicked] = useState(true);
  const searchClickHandler = (): any => {
    setClicked(true);
    if (!err) {
      onSearch();
    }
  };
  const inputRef = useRef<any>(null);
  useEffect((): any => {
    if (clicked) {
    if (inputRef.current) {
      setTimeout((): any => {
        inputRef?.current?.focus();
      });
    }
  }
  });

  useEffect((): any => {
    if ((value[0] && !value[1]) || (!value[0] && value[1])) {
      setErr('Minimum and maximum amount required.');
    } else if (value[0] && value[1] && Number(value[1]) < Number(value[0])) {
      setErr('Minimum amount must be less than maximum amount');
    } else {
      setErr('');
    }
  }, [value]);

  const clearFields = (): any => {
    onChange('', 0, true);
  };

  return (
    <React.Fragment>
      <Row className="custom-amount-range ant-input-affix-wrapper-focused">
        <Col>
          <Row gutter={GUTTOR_SPACE_SMALL}>
            <Col md={11}>
              <NumberFormat
                decimalScale={2}
                customInput={Input}
                thousandSeparator={true}
                thousandsGroupStyle="lakh"
                prefix="₹ "
                autoComplete="off"
                placeholder="Min amount"
                value={value[0]}
                getInputRef={inputRef}
                onChange={(event: any): any => {
                  setClicked(false);
                  onChange(replaceRsAndComma(event.target.value), 0);
                }}
              />
            </Col>
            <Col md={2}><SwapRightOutlined className="custom-swap-right-icon" /></Col>
            <Col md={11}>
              <NumberFormat
                decimalScale={2}
                customInput={Input}
                thousandSeparator={true}
                thousandsGroupStyle="lakh"
                prefix="₹ "
                autoComplete="off"
                placeholder="Max amount"
                value={value[1]}
                onChange={(event: any): any => onChange(replaceRsAndComma(event.target.value), 1)}
              />
            </Col>
          </Row>
          <span
              data-testid="address-clear"
              className="clear-btn"
              onClick={clearFields}
            >
              <CloseCircleFilled className="close-icon" />
            </span>
        </Col>
        {isSearchButtonRequired && <Col md={1}>
          <Button className="search-btn" icon={<SearchOutlined />} type="primary" onClick={searchClickHandler} />
        </Col>}
      </Row>
      {err && <Row className="error-text">{err}</Row>}
    </React.Fragment>
  );
};

export default AmountRangeSelector;
